import type { AxiosPromise } from 'axios';
import BaseClient, { type ExtendedAxiosRequestConfig } from './BaseClient';
import type { CursorPaginationResponse } from './api';
import type { TcrBrand, TcrCampaign, TcrListParams, TcrPhoneNumber } from './adminTenDlcClient.types';

class AdminTenDlcClient extends BaseClient {
    getTcrBrands(
        params?: TcrListParams,
        config?: ExtendedAxiosRequestConfig
    ): AxiosPromise<CursorPaginationResponse<TcrBrand>> {
        const url = '/api/admin/tcr-brands';
        return this.makeCoreApiRequest(url, 'get', null, params, config);
    }

    getTcrCampaigns(
        params?: TcrListParams,
        config?: ExtendedAxiosRequestConfig
    ): AxiosPromise<CursorPaginationResponse<TcrCampaign>> {
        const url = '/api/admin/tcr-campaigns';
        return this.makeCoreApiRequest(url, 'get', null, params, config);
    }

    getTcrPhoneNumbers(
        params?: TcrListParams,
        config?: ExtendedAxiosRequestConfig
    ): AxiosPromise<CursorPaginationResponse<TcrPhoneNumber>> {
        const url = '/api/admin/tcr-phone-numbers';
        return this.makeCoreApiRequest(url, 'get', null, params, config);
    }
}

export default new AdminTenDlcClient();
